import "./VideoModule.module.css";
import Header from "@/reusable_sections/Header";
import WarmUpGuideHero from "./sections/WarmUpGuideHero";
import VideoModules from "./sections/VideoModules";
import DrillInstructions from "./sections/DrillInstructions";
import Footer from "@/reusable_sections/Footer";
export default function VideoModulePage() {
  return <div>
      <Header />
      <WarmUpGuideHero />
      <VideoModules />
      <DrillInstructions />
      <Footer />
    </div>;
}